module.exports = __webpack_public_path__ + "static/scale-model-of-angle-lake-park-in-kent-washington-d5f0c6186bea90e86d61b0b3b74c404e.png";